var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExclamationCircleFill = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#fff",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.006 19.175c5.056 0 9.169-4.113 9.169-9.169 0-5.055-4.113-9.169-9.169-9.169-5.055 0-9.168 4.114-9.168 9.17 0 5.055 4.113 9.168 9.168 9.168M9.09 5.422a.917.917 0 1 1 1.834 0v4.584a.917.917 0 1 1-1.834 0zm0 8.252a.917.917 0 1 1 1.834 0 .917.917 0 0 1-1.834 0"
})));
export default SvgExclamationCircleFill;